export enum OnboardingCreationTypes {
    Default = 0,
    Connection = 1,
}
